import { createContext, useContext } from 'react'
import { Direction } from 'components/Animated'
import { CurrentUser } from 'customTypes'

const defaultValues = {
  stepIndex: -1,
  navigateToNextStep: (_user: CurrentUser) => {},
  navigateToPreviousStep: () => {},
  registerCallback: (_cb: () => boolean) => {},
  direction: Direction.Forward,
  resetBackDirection: () => {}
}

export const PaidVideoCallFlowContext = createContext(defaultValues)
export const usePaidVideoCallFlowContext = () => useContext(PaidVideoCallFlowContext)
